import { WeaTools } from 'ecCom'

export const getSearchCondition = (params) => {
    return  WeaTools.callApi('/api/hrm/trainrecord/getSearchCondition','GET',params);
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/trainrecord/getSearchResult', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/trainrecord.js